import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medical-record-section-config";

export const pagingMedicalRecordSectionConfig = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMedicalRecordSectionConfigById = (medicalRecordSectionConfigId) => axios.get(API_PATH + "/get-by-id/" + medicalRecordSectionConfigId);

export const saveOrUpdateMedicalRecordSectionConfig = medicalRecordSectionConfig => axios.post(API_PATH + "/save-or-update", medicalRecordSectionConfig);

export const deleteMedicalRecordSectionConfig = medicalRecordSectionConfigId => axios.delete(API_PATH + '/mark-delete/' + medicalRecordSectionConfigId);

export const getAllMedicalRecordSectionConfig = () => axios.get(API_PATH + '/get-all');
